import 'babel-polyfill';
import objectFitImages from 'object-fit-images';
import 'intersection-observer';

objectFitImages();

// JS Element.matches()
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.matchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector ||
    Element.prototype.oMatchesSelector ||
    Element.prototype.webkitMatchesSelector ||
    function m(s) {
      const matches = (this.document || this.ownerDocument).querySelectorAll(s);
      let i = matches.length;

      while (i - 1 >= 0 && matches.item(i) !== this) {
        i -= 1;
      }

      return i > -1;
    };
}
